import { render, staticRenderFns } from "./formStockCategorySelect.vue?vue&type=template&id=447861dc&"
import script from "./formStockCategorySelect.vue?vue&type=script&lang=js&"
export * from "./formStockCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports